import { Icon } from '@/general/Icons/Icon';

import { FilterName } from '@/plp/components/FilterName/FilterName';

import { FilterOption, PlpFilterBaseItemProps, PlpFiltersConditionalProps } from '../PlpFilters.type';
import { FilterAccordion } from '../components/FilterAccordion/FilterAccordion';
import { PlpFiltersRangePrice } from '../components/PlpFiltersRange/PlpFiltersRangePrice';

type Props = Prettify<
  PlpFilterBaseItemProps & {
    currentFilters: FilterOption[];
    options: {
      minCashOptions: FilterOption[];
      maxCashOptions: FilterOption[];
      minFinanceOptions: FilterOption[];
      maxFinanceOptions: FilterOption[];
    };
  } & PlpFiltersConditionalProps
>;

export const FilterPrice = ({ options, currentFilters, index, showNotificationBadge, ...props }: Props) => {
  const id = 'price';
  const header = (
    <FilterName icon={<Icon name="price" />} label="Price" showNotificationBadge={showNotificationBadge} />
  );
  const content = (
    <PlpFiltersRangePrice
      minCashOptions={options.minCashOptions}
      maxCashOptions={options.maxCashOptions}
      minFinanceOptions={options.minFinanceOptions}
      maxFinanceOptions={options.maxFinanceOptions}
      currentFilters={currentFilters}
      {...props}
    />
  );

  return <FilterAccordion id={id} header={header} content={content} index={index} />;
};
